
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/routes",
      function () {
        return require("private-next-pages/routes/index.tsx");
      }
    ]);
  